import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {NzMessageService} from 'ng-zorro-antd';
import {debounceTime, distinctUntilChanged, switchMap, takeUntil} from 'rxjs/operators';
import {BehaviorSubject, Subject} from 'rxjs';
import {ShopsService, RootService, MediasService} from 'src/app/services';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {getDateHelper} from '../../../shared/common/helper';

@Component({
  selector: 'app-media-statistic',
  templateUrl: './media-statistic.component.html',
  styleUrls: ['./media-statistic.component.scss']
})
export class MediaStatisticComponent implements OnInit, OnDestroy {

  unsubscribe$ = new Subject<void>();
  listCampaignsSearch = [];
  isLoading = false;
  page = 1;
  pageSize = 10;
  idSearch = undefined;
  fromDate;
  toDate;
  // tslint:disable-next-line:variable-name
  campaigns = [];
  query;
  total: number;
  loading = false;
  searchChange$ = new BehaviorSubject('');

  constructor(
    private message: NzMessageService,
    private shopService: ShopsService,
    private rootService: RootService,
    private notification: NzNotificationService,
    private mediasService: MediasService,
  ) {
    this.searchChange$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      takeUntil(this.unsubscribe$),
      switchMap(value => {
        this.isLoading = true;
        const query = {
          keyword: value,
          page: 1,
          page_size: 50
        };
        return this.mediasService.getAll(query);
      })
    ).subscribe(
      res => {
        this.isLoading = false;
        if (res.code === 1) {
          this.listCampaignsSearch = [];
          res.data.items.map(item => {
            const data = {
              label: item.name,
              value: item.id
            };
            this.listCampaignsSearch.push(data);
          });
          return;
        }
        this.listCampaignsSearch = [];
      },
      error => {
        this.isLoading = false;
        this.listCampaignsSearch = [];
      }
    );
  }

  ngOnInit() {

    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.loadData();
  }

  loadData() {
    this.loading = true;
    const campaignId$ = this.idSearch !== undefined ? this.idSearch : '';
    const fromDate$ = this.fromDate ? this.getDate(this.fromDate) : '';
    const toDate$ = this.toDate ? this.getDate(this.toDate) : '';
    this.query = {
      id: campaignId$,
      from: fromDate$,
      to: toDate$,
      page: this.page,
      page_size: this.pageSize
    };
    this.mediasService.statistical(this.query).pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          this.total  = res.data.totalElement;
          this.campaigns = res.data.items;
          return;
        }
        this.notification.error(
          'Lấy thống kê chiến dịch thất bại',
          res.message
        );
      },
      error => {
        this.loading = false;
        this.notification.error(
          'Lấy thống kê chiến dịch thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  searchCampaign(event) {
    this.searchChange$.next(event);
  }

  search() {
    this.page = 1;
    this.loadData();
  }

  reset() {
    this.page = 1;
    this.idSearch = undefined;
    this.toDate = '';
    this.fromDate = '';
    this.loadData();
  }

  getDate(date) {
    return getDateHelper(date);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
